import api from '../services/api';
import { IProcedure } from '../shared/interfaces';

interface IResponseGetProcedures {
  data: IProcedure[];
  count: number;
}
export const getProcedures = async (
  take: number,
  skip: number,
  keyword?: string,
): Promise<IResponseGetProcedures> => {
  const response = await api.post('/procedures/list', {
    take,
    skip,
    keyword,
  });
  return response.data;
};

export const postProcedure = async (payload: any): Promise<IProcedure> => {
  const response = await api.post(`/procedures`, payload);
  return response.data;
};

export const patchProcedure = async (
  id: string | undefined,
  payload: any,
): Promise<IProcedure> => {
  if (!id) {
    throw new Error('ID do procedimento não fornecido.');
  }
  const response = await api.patch(`/procedures/${id}`, payload);
  return response.data;
};

export const getSelectProcedures = async (
  param: 'all' | 'dental',
): Promise<IProcedure[]> => {
  const response = await api.get(`/procedures/select/${param}`);
  return response.data;
};
